export default __webpack_public_path__ + "static/media/uttarakhanda.5de9719f.png";